/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: inline-block;
}

.qds-label {
  box-sizing: border-box;
  color: var(--qds-theme-control-text-standard);
  display: inline-flex;
  gap: var(--qds-text-icon-gap);
  width: 100%;

  &:focus-visible {
    outline: var(--qds-focus-border-width) solid var(--qds-theme-focus-border);
    outline-offset: var(--qds-focus-border-offset);
    border-radius: var(--qds-focus-border-radius);
  }
}

.qds-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.qds-required {
  color: var(--qds-theme-feedback-field-required);
  user-select: none;
}

[data-size='small'] {
  font: var(--qds-control-small-text);

  &.qds-inline {
    margin-block: var(--qds-control-small-padding-auto-height);
  }
}

[data-size='standard'] {
  font: var(--qds-control-standard-text);

  &.qds-inline {
    margin-block: var(--qds-control-standard-padding-auto-height);
  }
}

[data-size='large'] {
  font: var(--qds-control-large-text);

  &.qds-inline {
    margin-block: var(--qds-control-large-padding-auto-height);
  }
}
